<div class="flex flex-col">
  <div
    [class.highlight]="highlight"
    class="relative flex flex-col mt-4 mb-6 text-black bg-primary-50 rounded-lg sm:flex-row"
  >
    <div class="flex flex-col items-center px-4 shrink-0">
      <img width="175" height="109" class="mt-10" src="assets/img/benefits.svg" alt="Korzyści" />
    </div>
    <div class="flex-grow p-5 text-sm md:text-xs">
      <div class="mb-3 font-bold leading-4 text-primary-700 lg:mb-4">
        Wszystkie Twoje rachunki w jednym miejscu!
      </div>
      <div class="mb-4 font-normal text-primary-900/60">
        Podłącz swoje rachunki do wybranego banku lub aplikacji i skorzystaj z udogodnień.
      </div>
      <ul>
        <li *ngFor="let benefit of BENEFITS" class="mb-1.5 flex items-center text-primary-700">
          <mat-icon class="mr-1 icon-16">check_circle_outline</mat-icon>
          <span class="font-normal text-xs">{{ benefit }}</span>
        </li>
      </ul>
    </div>
  </div>
</div>
